import { render, staticRenderFns } from "./bulkPromotion.vue?vue&type=template&id=8eb90594&"
import script from "./bulkPromotion.vue?vue&type=script&lang=js&"
export * from "./bulkPromotion.vue?vue&type=script&lang=js&"
import style0 from "./bulkPromotion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports